import React, { FC } from "react";

import "../styles.scss";
import "../scripts";

import {
  KameleonElement,
  getDefaultProps,
  primaryBlock,
} from "@kameleon-core/lib";
import { Box } from "theme-ui";
import { webflowHOC } from "@kameleon-common/webflow-js";
import { Variants } from "@kameleon-util/global-theme";
import {
  blockConfig,
  ContentCollectionItem,
  ContentCollectionItemType,
} from "./components/content-collection-item";

import blockinfo from "./blockinfo.json";
import defaults from "./defaults.json";
import {
  ContentCollectionType as ComponentType,
  layoutOptions,
} from "./types/prop-types";

type ContentCollectionType = {
  PrimaryBlocks: ContentCollectionItemType[];
} & ComponentType;

const ContentCollectionComponent: FC<ContentCollectionType> = ({
  PrimaryBlocks,
}: ContentCollectionType) => (
  <Box className="primary-collection-content-collection-two-col-tabs-medium-media-v1 section_layout403">
    <Box className="padding-global">
      <Box className="container-large padding-section-large">
        <Box
          data-current="Tab 1"
          data-easing="ease"
          data-duration-in="300"
          data-duration-out="100"
          className="layout403_component w-tabs"
        >
          <Box className="layout403_tabs-menu w-tab-menu">
            {PrimaryBlocks.map((primary, i) => (
              <Variants.LinkTab
                key={`tab-${i}`}
                data-w-tab={`Tab ${i + 1}`}
                className="layout403_tab-link small-on-mobile w-inline-block w-tab-link w--current"
              >
                <Variants.ParagraphDefault>
                  {primary.tab}
                </Variants.ParagraphDefault>
              </Variants.LinkTab>
            ))}
          </Box>
          <Box className="layout403_tabs-content w-tab-content">
            {PrimaryBlocks?.map((primaryBlockProps, i) => (
              <Box
                key={`item-${i}`}
                data-w-tab={`Tab ${i + 1}`}
                className="layout403_tab-pane w-tab-pane w--tab-active"
              >
                <ContentCollectionItem key={i} {...primaryBlockProps} />
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  </Box>
);

const ComponentWithWebflow = webflowHOC(ContentCollectionComponent, ["tabs"]);

export const ContentCollection = primaryBlock<ContentCollectionType>(
  blockConfig,
  ComponentWithWebflow
);
ContentCollection.defaultProps =
  getDefaultProps<ContentCollectionType>(defaults);

export const Element: KameleonElement = {
  component: ContentCollection,
  blockInfo: blockinfo,
  defaultProps: {
    layoutProps: defaults.layoutProps,
    contentProps: defaults.contentProps,
  },
  layoutOptions,
};
